export const staticTexts = () => {
  return {
    NUMBER_ARRAY: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
    saveToRead: "খবর সংরক্ষণ করে যেকোনো সময় যেকোনো ডিভাইস থেকে পড়তে পারবেন",
    localNews: "আমার এলাকার খবর",
    search: "খুঁজুন",
    "e-mail": "ই-মেইল",
    downloadMobileApps: "মোবাইল অ্যাপস ডাউনলোড করুন",
    newsYouCommented: "সংরক্ষিত কোন আইটেম নাই",
    newsYouSaved: "সংরক্ষিত কোন আইটেম নাই",
    editProfile: "এডিট প্রোফাইল",
    saveToReadLater: "পরবর্তীতে পড়ার জন্য সংরক্ষণ",
    alsoRead: "আরও পড়ুন",
    searchBoxText: " যা খুঁজতে চান",
    language: "বাংলা",
    edition: "সংস্করণ",
    loadMore: "আরও খবর",
    more: "আরও",
    relatedStories: "আরও খবর",
    morePhotoStories: "আরও ছবির গল্প",
    readMore: "আরও পড়ুন",
    advertising: "বিজ্ঞাপন",
    publishedAt: "প্রকাশ",
    updatedAt: "আপডেট",
    section: "বিভাগ",
    district: "জেলা",
    upazila: "উপজেলা",
    tag: "বিষয়",
    filterText: "বাছাই করুন",
    filterClearText: "মুছে ফেলুন",
    author: "লেখক",
    notifications: "নোটিফিকেশন",
    advanceSearch: "অনুসন্ধান",
    sekasana: "সেকশন",
    news: "খবর",
    sortOder: "সাজানো",
    date: "তারিখ",
    advanceSearchBox: "অনুসন্ধান করুন",
    resultsObtained: "প্রাপ্ত ফলাফল",
    breakingNews: "এইমাত্র পাওয়া",
    download: "ডাউনলোড",
    storyTypes: "ধরন",
    fromTheDate: "শুরুর তারিখ",
    upToNow: "শেষ তারিখ",
    shareOnFacebook: "ফেসবুকে শেয়ার করুন",
    pleaseEmail: "ইমেইল করুন",
    copyLink: "খবরের লিংক কপি করুন",
    print: "প্রিন্ট করুন",
    shareOnLinkedIn: "লিংকডইনে শেয়ার করুন",
    shareOnTwitter: "টুইটারে শেয়ার করুন",
    shareOnWatsapp: "ওয়াটসঅ্যাপে শেয়ার করুন",
    shareOnInsta: "ইনস্টাগ্রামে শেয়ার করুন",
    share: "শেয়ার",
    noResultsFound: "কিছু পাওয়া যায়নি",
    noResultsBreif:
      "আপনি যা খুঁজছেন, তা পাওয়া যায়নি। বিষয়টি সম্ভবত প্রথম আলোর নয় কিংবা আপনি ভুলভাবে খুঁজছেন। " +
      "দয়া করে, বিষয়টি সম্পর্কে নিশ্চিত হয়ে নিন।",
    cover: "প্রচ্ছদে ফিরে যান",
    nextVideo: "পরবর্তী ভিডিও",
    readComments: "মন্তব্য পড়ুন",
    doComment: "মন্তব্য করুন",
    yourCommentsWillBeSeenHere: "আপনার করা মন্তব্য এখানে পাওয়া যাবে",
    save: "সংরক্ষণ",
    logOut: "লগ আউট",
    savedPageTitle: "আপনার সংরক্ষিত খবর",
    savedPageSubTitle:
      "আপনার সংরক্ষণ করা গল্পগুলি আপনার পঠন তালিকায় যুক্ত করা হয়েছে। যে কোনও ডিভাইসে অ্যাক্সেস করুন।",
    seeAll: "সব দেখুন",
    commentApproved: "আপনার মন্তব্য প্রকাশিত হয়েছে",
    commentAwaitingApproval: "অনুমোদনের জন্য অপেক্ষমান",
    liveText: "সরাসরি",
    liveEndText: "সম্প্রচার শেষ",
    fewMomentsAgo: "কিছুক্ষণ আগে",
    oneMinuteAgo: "১ মিনিট আগে",
    minutesAgo: "মিনিট আগে",
    oneHourAgo: "১ ঘণ্টা আগে",
    hoursAgo: "ঘণ্টা আগে",
    detailsText: "বিস্তারিত...",
    newsletterText: "প্রথমআলো নিউজ লেটার",
    subscribeText: "সাবস্ক্রাইব",
    followUsText: "আমাদের সঙ্গে থাকুন",
    audio: "শুনুন",
    searchMetaTitle: "নিউজ সার্চ - চিরন্তন ১৯৭১ মুক্তিযুদ্ধের ইতিহাস | প্রথম আলো",
    searchMetaDescription:
      "নিউজ সার্চ করুন - মুক্তিযুদ্ধের দিনলিপি, শহীদ বুদ্ধিজীবী, বিশেষ দিনগুলি, বই, অডিও, ভিডিও, ছবি, খবর, একাত্তরের চিঠি, জনপদের যুদ্ধ, সাক্ষাৎকার - প্রথম আলো",
  };
};
